import { render, staticRenderFns } from "./LogosAIT.vue?vue&type=template&id=68b52934&scoped=true&"
import script from "./LogosAIT.vue?vue&type=script&lang=ts&"
export * from "./LogosAIT.vue?vue&type=script&lang=ts&"
import style0 from "./LogosAIT.vue?vue&type=style&index=0&id=68b52934&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b52934",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VImg,VRow,VSpacer})
